import { createTRPCProxyClient, httpBatchLink, httpLink } from "@trpc/client";
// NOTE: type only imports should ensure that the server code is not bundled with the clients
import type { AppRouter } from "@web/src/api/trpc-server";

export function makeTrpcClient(
  url: string,
  clientVersion: string,
  platform: string
) {
  let token: string | null = null;

  function setAccessToken(newToken: string | null) {
    token = newToken;
  }

  const trpc = createTRPCProxyClient<AppRouter>({
    links: [
      httpLink({
        url,
        headers() {
          return {
            Authorization: token || void 0,
            "X-Client-Version": clientVersion,
            "X-Client-Platform": platform,
          };
        },
      }),
    ],
  });

  return {
    client: trpc,
    setAccessToken,
  };
}

export type TrpcClient = ReturnType<typeof makeTrpcClient>["client"];
